<template>
  <div>
    <el-dialog
      :visible.sync="receiptNoVisible"
      v-model="receiptNoVisible"
      title="收货详情"
      width="80%"
      top="5%"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
    <div style="max-height: 600px; overflow: auto">
      <div class="receiptRow">
        <div>
          <div>
            <span>收货单号：</span>
            <span>{{ signForData.signForNumber }}</span>
          </div>
          <div>
            <span>仓库：</span>
            <span>{{ signForData.warehouseName }}</span>
          </div>
          <div>
            <span>进仓单号：</span>
            <span>{{ signForData.orgReceiptNo }}</span>
          </div>
          <div>
            <span>创建时间：</span>
            <span>{{ signForData.createTimeText }}</span>
          </div>
          <div>
            <span>完成收货时间：</span>
            <span>{{ signForData.completeReceiptDateText }}</span>
          </div>
          <div>
            <span>收货状态：</span>
            <span>{{ signForData.signForStatusText }}</span>
          </div>
          <div>
            <span>实收体积(cbm)：</span>
            <span>{{ signForData.totalVolume }}</span>
          </div>
        </div>
        <div>
          <div>
            <span>参考单号：</span>
            <span>{{ signForData.orgCustomerNo }}</span>
          </div>
          <div>
            <span>客户货主：</span>
            <span>{{ signForData.customName }}</span>
          </div>
          <div>
            <span>预计到仓时间：</span>
            <span>{{ signForData.estimatedDateText }}</span>
          </div>
          <div>
            <span>实际到仓时间：</span>
            <span>{{ signForData.actualArriveDateText }}</span>
          </div>
          <div>
            <span>完成上架时间：</span>
            <span>{{ signForData.completePutOnDateText }}</span>
          </div>
          <div>
            <span>实收箱数：</span>
            <span>{{ signForData.actualBoxCount }}</span>
          </div>
          <div>
            <span>实收毛重(kg)：</span>
            <span>{{ signForData.totalGrossWeight }}</span>
          </div>
        </div>
      </div>

      <!-- tab开始 -->
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
       
        <el-tab-pane label="预报信息" name="packingInformation">
          <div class="tabpaneFirst">
            预报箱数：{{ signForData.totalBoxCount }} 收货箱数：{{
              signForData.actualBoxCount
            }}
            上架箱数：{{ signForData.putOnBoxCount }}
          </div>
          <el-table :data="packingTableData" border style="width: 100%">
            <el-table-column
              prop="customerBox"
              label="箱号"
              minWidth="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="boxMark"
              label="箱唛"
              minWidth="180"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="boxLength"
              label="尺寸（长*宽*高）"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.boxLength }}*{{ scope.row.boxWidth }}*{{
                  scope.row.boxHeight
                }}
              </template>
            </el-table-column>
            <el-table-column prop="boxWeight" label="毛重" align="center">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="实收信息" name="receiptDetails">
          <div class="tabpaneFirst">
            预报箱数：{{ signForData.totalBoxCount }} 收货箱数：{{
              signForData.actualBoxCount
            }}
            上架箱数：{{ signForData.putOnBoxCount }}
          </div>
          <el-table :data="receiptTableData" border style="width: 100%">
            <el-table-column
              prop="customerBox"
              label="箱号"
              minwidth="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="boxMark"
              label="箱唛"
              minWidth="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              label="尺寸（长*宽*高）"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.actualBoxLength }}*{{
                  scope.row.actualBoxWidth
                }}*{{ scope.row.actualBoxHeight }}
              </template>
            </el-table-column>
            <el-table-column prop="actualBoxWeight" label="毛重" align="center">
            </el-table-column>
          </el-table>
        </el-tab-pane>
         <el-tab-pane label="实收汇总" name="collectedSummary">
          <el-table :data="collectedSummaryData" border style="width: 100%">
            <el-table-column prop="ownerCode" label="货主代码" align="center" />
            <el-table-column
              prop="actualBoxWeight"
              label="毛重(kg)"
              align="center"
            />
            <el-table-column
              prop="actualBoxVolume"
              label="体积(cbm)"
              align="center"
            />
            <el-table-column
              prop="actualBoxLength"
              label="长(cm)"
              align="center"
            />
            <el-table-column
              prop="actualBoxWidth"
              label="宽(cm)"
              align="center"
            />
            <el-table-column
              prop="actualBoxHeight"
              label="高(cm)"
              align="center"
            />
            <el-table-column prop="boxCount" label="箱数" align="center" />
            <el-table-column
              prop="declareCName"
              label="中文申报名称"
              align="center"
            />
            <el-table-column
              prop="declareEName"
              label="英文申报名称"
              align="center"
            />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="测量信息" name="machineData">
          <el-table :data="machineData" border style="width: 100%">
            <el-table-column
              prop="boxNumber"
              label="条码"
              align="center"
            />
            <el-table-column
              prop="boxLength"
              label="长(cm)"
              align="center"
            />
            <el-table-column
              prop="boxWidth"
              label="宽(cm)"
              align="center"
            />
            <el-table-column
              prop="boxHeight"
              label="高(cm)"
              align="center"
            />
             <el-table-column
              prop="boxVolume"
              label="体积(cbm)"
              align="center"
            />
            <el-table-column
              prop="boxWeight"
              label="毛重(kg)"
              align="center"
            />
            <el-table-column label="图片" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.pictureUrl && scope.row.pictureUrl != ''">
                  <el-link
                    :underline="false"
                    type="primary"
                    @click.native="downloadImages(scope.row.actualEntryDataId)"
                  >
                    下载
                  </el-link>
                </span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTimeText"
              label="测量时间"
              align="center"
            />
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="附件" name="appendix">
          <el-table :data="fileTableData" border style="width: 100%">
            <el-table-column
              prop="fileName"
              label="文件名"
              minwidth="200"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="createUser"
              label="打印人"
              minWidth="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="createTimeText"
              label="打印时间"
              align="center"
            >
            </el-table-column>
            <el-table-column label="文件" align="center">
              <template slot-scope="scope">
                <span>
                  <el-link
                    :underline="false"
                    type="primary"
                    @click.native="DownloadProductSKUAttachBtn(scope.row)"
                  >
                    下载
                  </el-link>
                </span>

                <br />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="托盘信息" name="palletData">
          <el-table :data="palletData" border style="width: 100%">
            <el-table-column
              prop="partCode"
              label="sku"
              align="center"
            />
            <el-table-column
              prop="palletQty"
              label="卡板数"
              align="center"
            />
            <el-table-column
              prop="boxQty"
              label="单托箱数"
              align="center"
            />
            <el-table-column
              prop="tailBoxQty"
              label="尾托箱数"
              align="center"
            />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- tab结束 -->
  </el-dialog>
  <!-- 图片预览组件 -->
  <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
  </viewer>
  </div>
</template>


<script>
import { getTFSignForTaskcByTFSignForID } from "@/api/transfer/tfSignFor/signInManage.js";
import { getActualDataImagesFileOut } from "@/api/outbound/outboundOrder.js";
import axios from "axios";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

export default {
  data() {
    return {
      collectedSummaryData: [],
      machineData:[],
      palletData:[],
      packingTableData: [],
      receiptTableData: [],
      activeName: "collectedSummary",
      receiptNoVisible: false,
      rowData: {},
      signForData: {},
      fileTableData: [],
      srcList: [],
    };
  },
  methods: {
    handleClick() {},
    showDialog(rowData) {
      this.receiptNoVisible = true;
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      this.rowData = rowData;
      getTFSignForTaskcByTFSignForID({
        tfSignForID: this.rowData.tfSignForID,
      }).then((res) => {
        loading.close();
        if (res.data.success) {
          this.signForData = res.data.response;
          this.packingTableData = res.data.response.deliveryBoxInfoList;
          this.receiptTableData = res.data.response.inventoryBoxList;
          this.fileTableData = res.data.response.fileInfoList;
          this.collectedSummaryData = res.data.response.summaryInventoryBoxList;
          this.machineData=res.data.response.machineData;
          this.palletData=res.data.response.palletData;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    DownloadProductSKUAttachBtn(file) {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      window.open(file.fileUrl, "_blank");

      loading.close();
    },
    //初始化viewer
    inited(viewer) {
      console.info(123);
      this.$viewer = viewer;
    },
    //下载照片
    downloadImages(id) {
      const data = {
        actualEntryDataId: id,
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(getActualDataImagesFileOut, {
          params: data,
        })
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style>
.el-loading-mask {
  z-index: 2026 !important;
}
</style>
<style scoped lang="less">
.receiptRow {
  display: flex;
  margin-bottom: 10px;
  > div {
    flex: 1;
    > div {
      margin-bottom: 10px;
      > span {
        display: inline-block;
      }
      > span:first-child {
        width: 130px;
        text-align: right;
        margin-right: 10px;
      }
      > span:last-child {
        color: #000;
      }
    }
  }
}
.tabpaneFirst {
  margin-bottom: 12px;
  text-align: right;
}
</style>